module.exports = __webpack_public_path__ + "img/dstv-change-package-3.8975aed5.jpg";